import cn from 'classnames';
import { PropsWithChildren } from 'react';
import './styles.scss';

interface Props<T> {
	tabs: { label: any; value: any; disabled?: boolean; cyTestRef?: string }[];
	activeTab: T;
	handleTabChange: (tab: T) => void;
	className?: string;
	activeTabDisabled?: boolean;
	isPillTab?: boolean;
	pillType?: 'primary' | 'secondary' | 'tertiary';
	cyCommonTabRef?: string;
	isBorderless?: boolean;
	centered?: boolean;
	reverseColors?: boolean;
}

const Tabs = <T = string,>({
	reverseColors = false,
	centered = false,
	tabs,
	className,
	activeTab,
	handleTabChange,
	activeTabDisabled = true,
	cyCommonTabRef,
	pillType = 'tertiary',
}: PropsWithChildren<Props<T>>) => {
	const handleClick = (tab: any, index: number) => {
		handleTabChange(tab);
	};

	return (
		<div
			className={cn({
				'tabs--centered': centered,
			})}
		>
			<div className={`tabs ${className}`}>
				{tabs.map((tab, index) => {
					const onClick = () =>
						activeTabDisabled ? activeTab !== tab.value && handleClick(tab.value, index) : handleClick(tab.value, index);
					return (
						<div
							className={cn('tabs__pillTab', {
								'tabs__pillTab--reversePillColor': reverseColors,
								[`tabs__pillTab--${pillType}`]: pillType,
								'tabs__pillTab--active': activeTab === tab.value,
							})}
							onClick={onClick}
							key={`tab--${index}`}
							data-cy={tab.cyTestRef || cyCommonTabRef}
						>
							{tab.label}
						</div>
					);
				})}
			</div>
		</div>
	);
};

export default Tabs;
